// extracted by mini-css-extract-plugin
module.exports = {"medium":"dropdown_medium__1b1ls","dropdowncontainer":"dropdown_dropdowncontainer__17v6p","arrowup":"dropdown_arrowup__3sNhd"};